import { useState, useEffect } from 'react'
import { pushToWindowResize, removeFromWindowResize } from 'src/helpers/browser'
import { useUniqueId } from 'src/hooks'
import { YLOPO_BASE_URL } from 'src/constants/listings'

const isScreenLargeEnoughForMap = () =>
  window.innerHeight > 649 && window.innerWidth > 799

const transformYlopoUrl = getter => url => {
  const id = useUniqueId('YlopoLinkSizer_')
  const [needsTransform, setNeedsTransform] = useState(getter())
  const toMap = needsTransform ? '/map' : ''

  useEffect(() => {
    pushToWindowResize(id, () => setNeedsTransform(getter()))
    return () => removeFromWindowResize(id)
  }, [id])

  return (
    !!url &&
    url.replace(
      new RegExp(`${YLOPO_BASE_URL}(/map)?`),
      `${YLOPO_BASE_URL}${toMap}`
    )
  )
}

export const transformYlopoUrlForSizeHook = transformYlopoUrl(
  isScreenLargeEnoughForMap
)
